import {
  IOrganisation,
  OrganisationWithExtras,
} from 'interfaces/IOrganisations';

export const formatOrganisationForTable = (
  org: IOrganisation
): OrganisationWithExtras => ({
  ...org,
  formattedAddress: [
    org.address1,
    org.city,
    org.state,
    org.postcode,
    org.country,
  ]
    .filter(Boolean)
    .join(', '),
  contactName: [org.firstName, org.lastName].filter(Boolean).join(' '),
  _searchText: [
    org.orgName,
    org.address1,
    org.city,
    org.state,
    org.postcode,
    org.country,
    org.firstName,
    org.lastName,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase(),
});
